import MainLayout from 'src/layouts';
import { Helmet } from 'react-helmet';
import BankTransfer from 'src/features/BankTransfer';
// import { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

const BankTransferPage = () => {
  return (
    <MainLayout hideSideBar={true}>
      <Helmet>
        <title>Bank Transfer</title>
      </Helmet>
      <BankTransfer />
    </MainLayout>
  );
};

export default BankTransferPage;
